import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
//首页 单页面900
import indexMainSpa from '@/view/indexSpa/main'
import indexspa from './indexSpa'


//关于投洽会
import AboutCifi from '@/view/AboutCifi'
import AboutCifiMain from '@/view/AboutCifi/main'
import aboutCifi from './aboutCifi'
//关于投洽会 单页面900 Spa spa
import AboutCifiMainSpa from '@/view/AboutCifiSpa/main'
import aboutcifispa from './AboutCifiSpa'


//新闻中心
import NewsCenter from '@/view/NewsCenter'
import NewsCenterMain from '@/view/NewsCenter/main'
import newsCenter from './newsCenter'
//新闻中心 单页面900
import NewsCenterMainSpa from '@/view/NewsCenterSpa/main'
import newscenterspa from './newsCenterSpa'


//展商指南
import Exhibitor from '@/view/Exhibitor'
import ExhibitorMain from '@/view/Exhibitor/main'
import exhibitor from './Exhibitor'
//展商指南 单页面900  Spa spa
import ExhibitorMainSpa from '@/view/ExhibitorSpa/main'
import exhibitorspa from './ExhibitorSpa'


//参会指南
import Participation from '@/view/Participation'
import ParticipationMain from '@/view/Participation/main'
import participation from './Participation'
//参会指南 单页面900
import ParticipationMainSpa from '@/view/ParticipationSpa/main'
import participationspa from './ParticipationSpa'


//论坛研讨会
import Forum from '@/view/Forum'
import ForumMain from '@/view/Forum/main'
import forum from './Forum'
//论坛研讨会  单页面
import ForumMainSpa from '@/view/ForumSpa/main'
import forumspa from './ForumSpa'


//项目对接
import Project from '@/view/Project'
import ProjectMain from '@/view/Project/main'
import project from './Project'
//项目对接 单页面
import ProjectMainSpa from '@/view/ProjectSpa/main'
import projectspa from './ProjectSpa'

//关于页面
import about from '@/view/about'

//资料中心
import Material from '@/view/Material'
import MaterialMain from '@/view/Material/main'
import material from './Material'
import history from './history'
// 资料中心  单页面
import MaterialMainSpa from '@/view/MaterialSpa/main'
import materialspa from './MaterialSpa'

//云上投洽会
// import newapp from '@/view/newapp'

//云上洽谈会
import xmArr from "./cloudFair/xm";
import fjArr from "./cloudFair/fj";
import bs from "./cloudFair/bs";
import otherArr from "./cloudFair/other";

import cloudFairArr from "./cloudFair/cloudFair";

//3D展厅，云展览
import exhibitionHall from '@/view/exhibitionHall'


Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       redirect: '/index',
//     },
//     {
//       path: '/index',
//       component: index,
//       meta: {
//         title:'国际投资贸易洽谈会官方网站',
//         keepAlive: true,
//       }
//     },{
//       path: '/indexSpa',
//       name: 'indexSpaPage',
//       component: indexMainSpa,
//       children: indexspa,
//       meta: {
//         title:'',
//         keepAlive: false,
//       }
//     },{
//       path: '/topic',//专题（主宾省）
//       name: 'TopicPage',
//       meta: {
//         title:'专题（主宾省）_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       },
//       component: () => import('@/view/topicSpa/topic.vue')
//     },{
//       path: '/slideDet',//轮播新闻详情
//       name: 'slideDetPage',
//       component: () => import('@/view/topicSpa/slideDet.vue')
//     },{
//       path: '/newsList',//新闻列表
//       name: 'newsList',
//       meta: {
//         title:'新闻列表_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       },
//       component: () => import('@/view/topicSpa/newsList.vue')
//     },{
//       path: '/AboutCifi',
//       name: 'AboutCifi',
//       component: AboutCifi,
//       meta: {
//         title: '关于投洽会_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       }
//     },{
//       path: '/AboutCifiMain',
//       name: 'AboutCifiMain',
//       component: AboutCifiMain,
//       children: aboutCifi,
//       meta: {
//         title:'关于投洽会_中国国际投资贸易洽谈会',

//         keepAlive: false,
//       }
//     },{
//       path: '/AboutCifiSpa',
//       name: 'AboutCifiSpa',
//       component: AboutCifiMainSpa,
//       children: aboutcifispa,
//       meta: {
//          title:'关于投洽会_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/NewsCenter',
//       name: 'NewsCenter',
//       component: NewsCenter,
//       meta: {
//         title:'新闻中心_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       }
//     },{
//       path: '/NewsCenterMain',
//       name: 'NewsCenterMain',
//       component: NewsCenterMain,
//       children: newsCenter,
//       meta: {
//          title:'新闻中心_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/NewsCenterSpa',
//       name: 'NewsCenterSpa',
//       component: NewsCenterMainSpa,
//       children: newscenterspa,
//       meta: {
//          title:'新闻中心_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/Exhibitor',
//       name: 'Exhibitor',
//       component: Exhibitor,
//       meta: {
//         title:'参展指南_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       }
//     },{
//       path: '/ExhibitorMain',
//       name: 'ExhibitorMain',
//       component: ExhibitorMain,
//       children: exhibitor,
//       meta: {
//          title:'参展指南_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/ExhibitorSpa',
//       name: 'ExhibitorSpa',
//       component: ExhibitorMainSpa,
//       children: exhibitorspa,
//       meta: {
//         title:'参展指南_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/Participation',
//       name: 'Participation',
//       component: Participation,
//       meta: {
//         title:'参会指南_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       }
//     },{
//       path: '/ParticipationMain',
//       name: 'ParticipationMain',
//       component: ParticipationMain,
//       children: participation,
//       meta: {
//          title:'参会指南_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/ParticipationMainSpa',
//       name: 'ParticipationMainSpa',
//       component: ParticipationMainSpa,
//       children: participationspa,
//       meta: {
//          title:'参会指南_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/Forum',
//       name: 'Forum',
//       component: Forum,
//       meta: {
//         keepAlive: true,
//       }
//     },{
//       path: '/ForumMain',
//       name: 'ForumMain',
//       component: ForumMain,
//       children: forum,
//       meta: {
//          title:'',
//         keepAlive: false,
//       }
//     },{
//       path: '/ForumMainSpa',
//       name: 'ForumMainSpa',
//       component: ForumMainSpa,
//       children: forumspa,
//       meta: {
//          title:'',
//         keepAlive: false,
//       }
//     },{
//       path: '/about',
//       name: 'about',
//       component: about,
//       meta: {
//         keepAlive: true,
//         title: '主要职责_中国国际投资贸易洽谈会'

//       }
//     },{
//       path: '/Project',
//       name: 'Project',
//       component: Project,
//       meta: {
//         keepAlive: true,
//         title: '项目对接_中国国际投资贸易洽谈会'
//       }
//     },{
//       path: '/ProjectMain',
//       name: 'ProjectMain',
//       component: ProjectMain,
//       children: project,
//       meta: {
//          title:'项目对接_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/ProjectMainSpa',
//       name: 'ProjectMainSpa',
//       component: ProjectMainSpa,
//       children: projectspa,
//       meta: {
//          title:'项目对接_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/Material',
//       name: 'Material',
//       component: Material,
//       meta: {
//         title:'资料中心_中国国际投资贸易洽谈会',
//         keepAlive: true,
//       }
//     },{
//       path: '/MaterialMain',
//       name: 'MaterialMain',
//       component: MaterialMain,
//       children: material,
//       meta: {
//         title:'资料中心_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },{
//       path: '/MaterialMain',
//       name: 'historyMain',
//       meta: {
//         title:'资料中心_中国国际投资贸易洽谈会',
//       },
//       component: MaterialMain,
//       children: history,
//     },{
//       path: '/MaterialMainSpa',
//       name: 'MaterialMainSpa',
//       component: MaterialMainSpa,
//       children: materialspa,
//       meta: {
//          title:'资料中心_中国国际投资贸易洽谈会',
//         keepAlive: false,
//       }
//     },

//   ],

//   scrollBehavior (to, from, savedPosition) {

//     if (savedPosition) {
//       return savedPosition
//     } else {
//       if (from.meta.keepAlive) {
//         from.meta.savedPosition = document.body.scrollTop
//       }
//       return { x: 0, y: to.meta.savedPosition || 0 }
//     }
//   }
// })
let routeArr = [
  {
    path: '/exhibitionHall',
    component: exhibitionHall,
    name: "3D展厅",
    meta: {
      title: '3D展厅_中国国际投资贸易洽谈会',
      keepAlive: true,
    }
  },
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    component: index,
    meta: {
      title: '国际投资贸易洽谈会官方网站',
      keepAlive: true,
    }
  },
  {
    path: '/indexSpa',
    name: 'indexSpaPage',
    component: indexMainSpa,
    children: indexspa,
    meta: {
      title: '',
      keepAlive: false,
    }
  }, {
    path: '/topic',//专题（主宾省）
    name: 'TopicPage',
    meta: {
      title: '专题_中国国际投资贸易洽谈会',
      keepAlive: true,
    },
    component: () => import('@/view/topicSpa/topic.vue')
  }, {
    path: '/slideDet',//轮播新闻详情
    name: 'slideDetPage',
    component: () => import('@/view/topicSpa/slideDet.vue')
  }, {
    path: '/newsList',//新闻列表
    name: 'newsList',
    meta: {
      title: '新闻列表_中国国际投资贸易洽谈会',
      keepAlive: true,
    },
    component: () => import('@/view/topicSpa/newsList.vue')
  }, {
    path: '/AboutCifi',
    name: 'AboutCifi',
    component: AboutCifi,
    meta: {
      title: '关于投洽会_中国国际投资贸易洽谈会',
      keepAlive: true,
    }
  }, {
    path: '/AboutCifiMain',
    name: 'AboutCifiMain',
    component: AboutCifiMain,
    children: aboutCifi,
    meta: {
      title: '关于投洽会_中国国际投资贸易洽谈会',

      keepAlive: false,
    }
  }, {
    path: '/AboutCifiSpa',
    name: 'AboutCifiSpa',
    component: AboutCifiMainSpa,
    children: aboutcifispa,
    meta: {
      title: '关于投洽会_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/NewsCenter',
    name: 'NewsCenter',
    component: NewsCenter,
    meta: {
      title: '新闻中心_中国国际投资贸易洽谈会',
      keepAlive: true,
    }
  }, {
    path: '/NewsCenterMain',
    name: 'NewsCenterMain',
    component: NewsCenterMain,
    children: newsCenter,
    meta: {
      title: '新闻中心_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/NewsCenterSpa',
    name: 'NewsCenterSpa',
    component: NewsCenterMainSpa,
    children: newscenterspa,
    meta: {
      title: '新闻中心_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/Exhibitor',
    name: 'Exhibitor',
    component: Exhibitor,
    meta: {
      title: '参展指南_中国国际投资贸易洽谈会',
      keepAlive: true,
    }
  }, {
    path: '/ExhibitorMain',
    name: 'ExhibitorMain',
    component: ExhibitorMain,
    children: exhibitor,
    meta: {
      title: '参展指南_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/ExhibitorSpa',
    name: 'ExhibitorSpa',
    component: ExhibitorMainSpa,
    children: exhibitorspa,
    meta: {
      title: '参展指南_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/Participation',
    name: 'Participation',
    component: Participation,
    meta: {
      title: '参会指南_中国国际投资贸易洽谈会',
      keepAlive: true,
    }
  }, {
    path: '/ParticipationMain',
    name: 'ParticipationMain',
    component: ParticipationMain,
    children: participation,
    meta: {
      title: '参会指南_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/ParticipationMainSpa',
    name: 'ParticipationMainSpa',
    component: ParticipationMainSpa,
    children: participationspa,
    meta: {
      title: '参会指南_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/Forum',
    name: 'Forum',
    component: Forum,
    meta: {
      keepAlive: true,
    }
  }, {
    path: '/ForumMain',
    name: 'ForumMain',
    component: ForumMain,
    children: forum,
    meta: {
      title: '',
      keepAlive: false,
    }
  }, {
    path: '/ForumMainSpa',
    name: 'ForumMainSpa',
    component: ForumMainSpa,
    children: forumspa,
    meta: {
      title: '',
      keepAlive: false,
    }
  }, {
    path: '/about',
    name: 'about',
    component: about,
    meta: {
      keepAlive: true,
      title: '主要职责_中国国际投资贸易洽谈会'

    }
  }, {
    path: '/Project',
    name: 'Project',
    component: Project,
    meta: {
      keepAlive: true,
      title: '项目对接_中国国际投资贸易洽谈会'
    }
  }, {
    path: '/ProjectMain',
    name: 'ProjectMain',
    component: ProjectMain,
    children: project,
    meta: {
      title: '项目对接_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/ProjectMainSpa',
    name: 'ProjectMainSpa',
    component: ProjectMainSpa,
    children: projectspa,
    meta: {
      title: '项目对接_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/Material',
    name: 'Material',
    component: Material,
    meta: {
      title: '资料中心_中国国际投资贸易洽谈会',
      keepAlive: true,
    }
  }, {
    path: '/MaterialMain',
    name: 'MaterialMain',
    component: MaterialMain,
    children: material,
    meta: {
      title: '资料中心_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  }, {
    path: '/MaterialMain',
    name: 'historyMain',
    meta: {
      title: '资料中心_中国国际投资贸易洽谈会',
    },
    component: MaterialMain,
    children: history,
  }, {
    path: '/MaterialMainSpa',
    name: 'MaterialMainSpa',
    component: MaterialMainSpa,
    children: materialspa,
    meta: {
      title: '资料中心_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  },
  // 首页-云会议
  {
    name: 'CloudConference',
    path: '/CloudConference',
    component: () => import('@/view/cloud-conference/index'),
    meta: {
      title: '云会议_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  },
  {
    name: 'MeetingDetails',
    path: '/CloudConference/MeetingDetails',
    component: () => import('@/view/cloud-conference/meeting-details'),
    meta: {
      title: '会议详情_中国国际投资贸易洽谈会',
      keepAlive: false,
    }
  },
  // 投洽会

];
routeArr = [
  ...routeArr,
  ...cloudFairArr,
  ...xmArr,
  ...fjArr,
  ...bs,
  ...otherArr
];

export default new Router({
  routes: routeArr,
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //    } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js